import { useTranslation } from "react-i18next";
import { useTime } from "utils";

interface LastWorkoutDateCellProps {
  active: boolean;
  date: string | null;
}

export function LastWorkoutDateCell(props: LastWorkoutDateCellProps) {
  const { t } = useTranslation();
  const time = useTime();

  if (!props.active) {
    return props.date ? time.formatCivilDate(props.date, "shortDate") : "-";
  }

  if (!props.date) {
    return "-";
  }

  const today = time.civilDateOfInstant(new Date());
  const daysUntilLastWorkout = time.differenceInCivilDays(today, props.date);

  if (daysUntilLastWorkout < 0) {
    return "-";
  }

  const formattedDate = time.formatCivilDate(props.date, "shortDate");
  const endingSoon = daysUntilLastWorkout <= 7;
  const label =
    daysUntilLastWorkout === 0
      ? t("athletesPage.lastWorkoutStatus.endsToday")
      : t("athletesPage.lastWorkoutStatus.daysLeft", {
          count: daysUntilLastWorkout,
        });

  return (
    <div className="flex flex-col gap-0.5">
      <div className="inline-flex items-center gap-2">
        {endingSoon ? (
          <span aria-hidden className="size-2 rounded-full bg-amber-500" />
        ) : null}
        <span>{label}</span>
      </div>
      <span className="text-xs text-muted-foreground">{formattedDate}</span>
    </div>
  );
}
